import * as React from 'react';

interface TabPanelProps {
  active: boolean;
}

const TabPanel: React.SFC<TabPanelProps> = (props) => {
  const { active, children } = props;
  const tabPanelStyle: React.CSSProperties = {
    // Use "visibility: hidden" instead of "display: none" to work around chrome's bug.
    // https://git.bpsinc.jp/app/ark-viewer-js/issues/126
    visibility: active ? 'visible' : 'hidden',
    // display: active ? 'block' : 'none',
    position: 'absolute',
    left: '0',
    top: '0',
    right: '0',
    bottom: '0',
    touchAction: 'none',
  };

  return (
    <section style={tabPanelStyle}>
      {children}
    </section>
  );
};

export default TabPanel;
